import { Injectable, OnDestroy } from "@angular/core";
import { SendMailModel } from "../../../../models";
import { CoreService, HttpService } from "../../../../services";
import { StageService } from "../services/stage-modal.service";

/*
* Services pour la gestion des mails
*/
@Injectable()
export class MailService implements OnDestroy {
  /* model global du mail*/
  public modelMail: SendMailModel;
  /* boolean pour savoir si la liste de destination est vide*/
  public lstDestIsEmpty: boolean;
  /* liste des documents sélectionnés*/
  public lstDocumentsSelected: string[];
  constructor(
    public service: StageService,
    protected http: HttpService,
    protected indParam: CoreService,

  ) {
    this.modelMail = new SendMailModel();
    this.lstDestIsEmpty = true;
    this.modelMail.RecipientList = [];
    this.modelMail.ListDocAffected = [];
    this.lstDocumentsSelected = [];

  }

  /*  tableaux utilisé pour afficher les étapes au clic */
  public tabs: Array<{ Title: string, Type: MailOnglet, Sonar: boolean, Icon: string, Name: string, Active: boolean, Visible: boolean, Locked: boolean, Class: string }> = [
    { Title: "Etape 1", Active: false, Visible: true, Sonar: true, Locked: true, Name: 'Sélection du/des destinataires', Type: MailOnglet.MailStepOne, Icon: '<i class="fas fa-users"></i>', Class: "" },
    { Title: "Etape 2", Active: false, Visible: true, Sonar: true, Locked: false, Name: 'Choix des documents', Type: MailOnglet.MailStepTwo, Icon: '<i class="fas fa-file-word">', Class: "" },
    { Title: "Etape 3", Active: false, Visible: true, Sonar: true, Locked: false, Name: 'Visualisation et envoi du mail', Type: MailOnglet.MailStepThree, Icon: '<i class="fas fa-eye"></i>', Class: "" }
  ];

  /** Vérifie si la liste des destinataires est vide, si oui l'étape 2 n'est pas cliquable */
  public VerifyIfListDestIsEmpty() {
    this.modelMail.RecipientList.length > 0 ? this.lstDestIsEmpty = false : this.lstDestIsEmpty = true;
    if (this.lstDestIsEmpty) {
      this.tabs[1].Class = "nonCliquable";
      this.tabs[1].Sonar = false;
    } else {
      this.tabs[1].Class = "";
      this.tabs[1].Sonar = true;
    }
  }
  ngOnDestroy(): void { }
}
export enum MailOnglet {
  MailStepOne,
  MailStepTwo,
  MailStepThree,
}
